import { formatCurrency } from "@oefr/utils/formatter/currency"

type QuoteOfferFrequency = "annual" | "monthly"

const INCLUDING_TAXES_LABEL = "TTC"

const FREQUENCY_LABEL: Record<QuoteOfferFrequency, string> = {
    annual: "/an",
    monthly: "/mois",
}

type FormatPaymentAmountOptions = {
    amount: number
    frequency?: QuoteOfferFrequency
    includingTaxes?: boolean
}

export function formatPaymentAmount({
    amount,
    frequency,
    includingTaxes,
}: FormatPaymentAmountOptions) {
    const formattedAmount = formatCurrency(amount)

    const frequencyLabel = frequency && FREQUENCY_LABEL[frequency]
    const includingTaxesLabel = includingTaxes && INCLUDING_TAXES_LABEL
    const priceSuffix = [includingTaxesLabel, frequencyLabel].filter(Boolean).join("")

    return [formattedAmount, priceSuffix].filter(Boolean).join(" ")
}
